import { CONFIG } from "../i18n";

const PrivacyPage = ({ t }) => (
  <main className="privacy" data-testid="privacy-page">
    <div className="privacy-inner">
      <h1>{t.privacy.title}</h1>
      <p className="privacy-intro">{t.privacy.intro}</p>
      {t.privacy.sections.map((s, i) => (
        <section key={i}>
          <h2>{s.h}</h2>
          {s.p.map((p, j) => (
            <p key={j}>{p}</p>
          ))}
        </section>
      ))}
      <p className="privacy-contact">
        {t.privacy.contact} <a href={`mailto:${CONFIG.email}`} data-testid="privacy-email-link">{CONFIG.email}</a>
      </p>
    </div>
  </main>
);

export default PrivacyPage;
